var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"basic_button height_fill",style:({
       width: _vm.listArr.module_style == 2 || _vm.listArr.module_style == 4 ? 'auto' : '100%'
     }),on:{"click":function($event){$event.stopPropagation();return _vm.templet.is_jump({href:("#/product?id=" + (_vm.item.goods_id) + "&tag_id=" + (_vm.item.tag_ids)),target:_vm.fromTag === 'search' ? '_blank' : _vm.pc_infor.target})}}},[_c('div',{staticClass:"buttonContent",class:_vm.pc_infor.button_text.styleType,style:({
       height: '100%',
       '--borderSeColor': _vm.borderSeColor,
       '--borderColor': _vm.borderColor,
       '--backgroundColor': _vm.backgroundColor,
       '--backgroundSeColor': _vm.backgroundSeColor,
       '--fontColor': _vm.fontColor,
       '--fontSeColor': _vm.fontSeColor,
       borderStyle:_vm.pc_infor.button_text.buttonStyle.borderStyle,
       borderWidth:_vm.pc_infor.button_text.buttonStyle.borderWidth + 'px',
       borderRadius: _vm.pc_infor.button_text.buttonStyle.borderRadius + 'px'
     })},[_c('div',{staticClass:"bothHeight"},[_c('span',{staticClass:"btnLink"},[_c('div',{staticClass:"edit-div btnWords",style:({
             fontSize: (_vm.pc_infor.product_name_font[_vm.pc_infor.product_name_font.radio_val].fontSize - 4) + 'px',
             fontFamily: _vm.pc_infor.product_name_font[_vm.pc_infor.product_name_font.radio_val].fontFamily
           })},[_vm._v(_vm._s(_vm.pc_infor.button_text.value))]),_vm._v(" "),_c('span',{staticClass:"after"})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04259b09","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/basic_product_display/components/detail_button.vue
// module id = null
// module chunks = 